import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import replaceWebpackDynamicImport from './utils/ReplaceDynamicImport';

window.replaceWebpackDynamicImport = replaceWebpackDynamicImport;

ReactDOM.render(<App />, document.getElementById('root'));
